import { render, staticRenderFns } from "./ObservationEditor.vue?vue&type=template&id=38d98a1b"
import script from "./ObservationEditor.vue?vue&type=script&lang=ts"
export * from "./ObservationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports